import { Box, Button, Text, Flex, Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { StoreSection } from '../components/DashboardStyles';
import { BsDownload, BsSearch } from 'react-icons/bs';
import { LuPlusSquare } from 'react-icons/lu';
import SelectionTable from 'components/Store/SelectionTable';
import { config } from 'config/config';
import { isEmpty } from 'lodash';

const PartnerStore = () => {
    const navigate = useNavigate();
    let [isStoreEmpty] = useState(false);
    const storeReducer = useSelector((state) => state.storeReducer);
    const { store } = storeReducer;

    const storeLink = `${config.baseUrl}/store/${store?.link}`;

    useEffect(() => {
        if (!store) return navigate('/dashboard/store/create-a-store');
        if (isEmpty(store.storeProducts))
            return navigate('/dashboard/store/products/create-product');
    }, [navigate, store]);

    return (
        <StoreSection>
            <Flex justifyContent="space-between" flexDir={{ base: 'column', lg: 'row' }}>
                <Flex flexDir="column">
                    <Text width="100%" fontSize="2xl" fontWeight="bold">
                        Hello, {store?.name}
                    </Text>
                    <Text fontSize="2xl" fontWeight="bold">
                        Welcome to your Store
                    </Text>
                    {isStoreEmpty ? (
                        <>
                            <Text mt="4" mb="2">
                                You have not added any products to your store
                            </Text>
                            <Box
                                display="flex"
                                flexDirection={{
                                    base: 'column',
                                    sm: 'column',
                                    md: 'row',
                                    lg: 'row',
                                }}
                                gap="1rem">
                                <Button
                                    fontSize="xs"
                                    background="#1b3b5f"
                                    color="#ffffff"
                                    onClick={() =>
                                        navigate('/dashboard/store/products/create-product')
                                    }
                                    _hover={{
                                        background: 'none',
                                        color: '#1b3b5f',
                                        border: '1px solid #1b3b5f',
                                    }}>
                                    Add Product
                                </Button>
                                <Button
                                    fontSize="xs"
                                    color="#1b3b5f"
                                    background="#ffffff"
                                    border="1px solid #1b3b5f"
                                    onClick={(e) => navigate('/dashboard/products')}
                                    _hover={{
                                        background: '#1b3b5f',
                                        color: '#ffffff',
                                        border: '1px solid #ffffff',
                                    }}>
                                    Buy Products from Obana
                                </Button>
                            </Box>
                        </>
                    ) : null}
                </Flex>
                <Flex gap="6">
                    {isStoreEmpty ? (
                        <></>
                    ) : (
                        <>
                            <Button
                                background="#1b3b5f"
                                _hover={{
                                    bg: '#fff',
                                    border: '1px solid #1b3b5f',
                                    color: '#1b3b5f',
                                }}
                                color="white"
                                fontWeight="medium"
                                onClick={() => window.open(storeLink, '_blank')}>
                                Preview store
                            </Button>
                            <Button
                                variant="outline"
                                fontWeight="medium"
                                onClick={() => navigate('/dashboard/store/create-a-store/form')}>
                                Store settings
                            </Button>
                        </>
                    )}
                </Flex>
            </Flex>
            {isStoreEmpty ? null : (
                <>
                    <Box className="BannerImg" mt="5" position="relative">
                        <Button top={{ base: '87%', lg: '87%' }} left={{ base: '40%', lg: '87%' }}>
                            Update Banner
                        </Button>
                    </Box>

                    <Flex my="10" flexDir="column">
                        <Text fontSize="2xl" fontWeight="medium">
                            My Products
                        </Text>
                        <Flex mt="7" mb="5" w="full" justifyContent="space-between">
                            <Flex>
                                <InputGroup>
                                    <InputLeftElement color="gray.500" pointerEvents="none">
                                        <BsSearch />
                                    </InputLeftElement>
                                    <Input
                                        type="tel"
                                        placeholder="Search products"
                                        // onChange={(e) => onSearch(e.target.value)}
                                    />
                                </InputGroup>
                            </Flex>
                            <Flex gap="2">
                                <Button variant="outline" bg="#fff">
                                    <BsDownload color="#000" />
                                </Button>
                                <Button
                                    bg="#1b3b5f"
                                    onClick={() =>
                                        navigate('/dashboard/store/products/create-product')
                                    }>
                                    <LuPlusSquare color="#fff" />
                                </Button>
                            </Flex>
                        </Flex>
                        <SelectionTable />
                    </Flex>
                </>
            )}
        </StoreSection>
    );
};

export default PartnerStore;
